<template>
    <div>
        <UserSelector
            ref="userSelector"
            :value="getSelectedStudents()"
            @input="selectStudents"
            :users="options"
            :label="`${selectedStudents.length} ${$t('students-selected')}`"
            class="mb-3"
            :disableNoneSelectedAlert="true"
            :hideSelected="true"
        />
        <GroupMultiSelect 
            v-if="allGroups.length"
            :value="selectedGroups"
            :groups="allGroups"
            @input="updateSelectedGroups"
        />
        <div v-for="(years, programmeId) in allStudentsByGroup" :key="programmeId" class="row">
            <template v-for="(groups, year) in years">
            <template v-for="(users, groupId) in groups">
            <div 
                v-if="selectedGroups.findIndex(el => el.programme_id == programmeId && el.year == year && el.group_id == groupId) > -1"
                :key="`${programmeId}-${year}-${groupId}`"
                class="col-12 col-xl-6 col-xxl-4"
            >
                <UserSelector
                    :value="selectedStudentsByGroup[programmeId][year][groupId]"
                    @input="val => updateSelectedStudents(val, programmeId, year, groupId)"
                    :users="users"
                    :label="$t('year')+' '+year+', '+$t('group')+' '+$config.getValue('groups')[groupId]"
                    class="border rounded p-2 my-2"
                />
            </div>
            </template>
            </template>
        </div>
    </div>
</template>

<script>
import UserSelector from '../Users/UserSelector.vue'
import GroupMultiSelect from '../ProgrammeYearGroups/GroupMultiSelect.vue'

export default {
    components: {
        UserSelector,
        GroupMultiSelect,
    },
    props: {
        value: Array,
        options: Array,
    },
    mounted() {
        this.sortStudents(this.options, this.selectedStudents)
    },
    data() {
        return {
            selectedStudents: this.value,
            allGroups: [],
            selectedGroups: [],
            allStudentsByGroup: {},
            selectedStudentsByGroup: {},
        }
    },
    methods: {
        sortStudents(allStudents, selectedStudents) {
            this.allStudentsByGroup = {}
            this.selectedStudentsByGroup = {}

            const studentsByIndex = allStudents.reduce((prev, curr) => {
                prev[curr.id] = curr
                return prev
            }, {})

            selectedStudents = selectedStudents.map(student => studentsByIndex[student.id]).filter(student => !!student)

            this.allGroups = []
            
            allStudents.forEach(student => {
                if (!this.allStudentsByGroup[student.programme_id]) {
                    this.allStudentsByGroup[student.programme_id] = {}
                    this.selectedStudentsByGroup[student.programme_id] = {}
                }
                if (!this.allStudentsByGroup[student.programme_id][student.year]) {
                    this.allStudentsByGroup[student.programme_id][student.year] = {}
                    this.selectedStudentsByGroup[student.programme_id][student.year] = {}
                }
                if (!this.allStudentsByGroup[student.programme_id][student.year][student.group_id]) {
                    this.allGroups.push({programme_id: student.programme_id, year: student.year, group_id: student.group_id})

                    this.allStudentsByGroup[student.programme_id][student.year][student.group_id] = []
                    this.selectedStudentsByGroup[student.programme_id][student.year][student.group_id] = []
                }

                this.allStudentsByGroup[student.programme_id][student.year][student.group_id].push(student)

                let index = selectedStudents.findIndex(el => el.id === student.id)
                if (index > -1) this.selectedStudentsByGroup[student.programme_id][student.year][student.group_id].push(selectedStudents[index])
            })

            this.selectedGroups = this.getStudentGroups(selectedStudents)
            this.selectedStudents = this.getSelectedStudents()
        },
        updateSelectedGroups(newGroups) {
            const key = (gr) => `${gr.programme_id}-${gr.year}-${gr.group_id}`

            const newMap = newGroups.reduce((prev, curr) => {
                prev[key(curr)] = true
                return prev
            }, {})
            const oldMap = this.selectedGroups.reduce((prev, curr) => {
                prev[key(curr)] = true
                return prev
            }, {})

            const add = []
            const remove = []

            newGroups.forEach(gr => {
                if (!oldMap[key(gr)]) add.push(gr)
            })
            this.selectedGroups.forEach(gr => {
                if (!newMap[key(gr)]) remove.push(gr)
            })

            add.forEach(gr => {
                this.selectedStudentsByGroup[gr.programme_id][gr.year][gr.group_id] = [...this.allStudentsByGroup[gr.programme_id][gr.year][gr.group_id]]
            })
            remove.forEach(gr => {
                this.selectedStudentsByGroup[gr.programme_id][gr.year][gr.group_id] = []
            })

            this.selectedGroups = newGroups
            this.selectedStudents = this.getSelectedStudents()
        },
        updateSelectedStudents(students, programmeId, year, groupId) {
            this.selectedStudentsByGroup[programmeId][year][groupId] = students
            this.selectedStudents = this.getSelectedStudents()
        },
        getSelectedStudents() {
            const students = []

            Object.keys(this.selectedStudentsByGroup).forEach(programme => {
                Object.keys(this.selectedStudentsByGroup[programme]).forEach(year => {
                    Object.keys(this.selectedStudentsByGroup[programme][year]).forEach(group => {
                        students.push(...this.selectedStudentsByGroup[programme][year][group])
                    })
                })
            })

            return students
        },
        selectStudents(students) {
            this.sortStudents(this.options, students)
            this.$refs.userSelector.showOptions = false
        },
        getStudentGroups(students) {
            return Object.values(students.reduce((prev, curr) => {
                prev[`${curr.programme_id}-${curr.year}-${curr.group_id}`] = {
                    programme_id: curr.programme_id,
                    year: curr.year,
                    group_id: curr.group_id,
                }
                return prev
            }, {}))
        },
    },
    watch: {
        selectedStudents(newVal) {
            this.$emit('input', newVal)
        }
    }
}
</script>